module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"english":"Engleski","croatian":"Hrvatski"},"hr":{"english":"English","croatian":"Croatian"}}')
  delete Component.options._Ctor
}
